import React from 'react';
import Title from '../../../../../@casino/ui/title';
import {useRouter} from '../../../../../@casino/useRouter';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import {useFormik, FormikContext} from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { setGetViewExchangeRates } from '../../store/thunk/setGetViewExchangeRates';
import { setPostUpdateExchangeRates } from '../../store/thunk/setPostUpdateExchangeRates';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%', 
    },
    mt0: {
        marginTop: 0
    },
    wrapActiveBonus: {
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '70%'
    },
}))

const ExchangeRatesEdit = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const router = useRouter();
    const {id} = router.query;

    React.useEffect(() => {
        dispatch(setGetViewExchangeRates({id}))
    }, [id])

    const initialValues = useSelector(state => state.exchangeRates.view);

    const onSubmit = (store) => {
        dispatch(setPostUpdateExchangeRates(store))
    }

    const enableReinitialize = true;
    
    const formik = useFormik({initialValues, onSubmit, enableReinitialize});

    return (
        <div style={{padding: '0 20px'}}>
            <Title 
                label="Добавление валютной пары" 
                labelBtn="Назад"
                button={() => router.history.push('/settings/exchange-rates')}    
            />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
            }}>
                <FormikContext.Provider value={formik}>
                    <form onSubmit={formik.handleSubmit}>
                        <div style={{display: 'flex', columnGap: 12}}>
                            <label htmlFor="to_currency" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                                <span className={classes.helper}>Валюта</span>
                                <input 
                                    type="text" 
                                    name="to_currency" 
                                    id="to_currency" 
                                    className={classes.text}
                                    value={formik.values.to_currency} 
                                    onChange={(v) => formik.setFieldValue('to_currency', v.target.value)}
                                />
                            </label>
                            <label htmlFor="from_currency" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                                <span className={classes.helper}>Валюта</span>
                                <input 
                                    type="text" 
                                    name="from_currency" 
                                    id="from_currency" 
                                    className={classes.text}
                                    value={formik.values.from_currency} 
                                    onChange={(v) => formik.setFieldValue('from_currency', v.target.value)}
                                />
                            </label>
                        </div>
                        <label htmlFor="link" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>Курс</span>
                            <input 
                                type="text" 
                                name="link" 
                                id="link" 
                                className={classes.text}
                                value={formik.values.value} 
                                onChange={(v) => formik.setFieldValue('value', v.target.value)}
                            />
                        </label>
                        <div>
                            <span 
                                onClick={() => formik.submitForm()}
                                style={{
                                    color: '#141b33',
                                    cursor: 'pointer',
                                    padding: '10px',
                                    background: '#ffc324',
                                    borderRadius: '4px',
                                }}
                            >
                                Сохранить
                            </span>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
        </div>
    )
}

export default ExchangeRatesEdit;